var React = require('react');

function IconClose (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"icon-x"),React.createElement("g",{"fill":"currentColor","fillRule":"evenodd","key":1},[React.createElement("rect",{"transform":"rotate(45 12 12)","x":"3","y":"11","width":"18","height":"2","rx":"1","key":0}),React.createElement("rect",{"transform":"rotate(-45 12 12)","x":"3","y":"11","width":"18","height":"2","rx":"1","key":1})])]);
}

IconClose.defaultProps = {"id":"icon-x","viewBox":"0 0 24 24","width":"24px","height":"24px"};

module.exports = IconClose;

IconClose.default = IconClose;
